export default "__VITE_ASSET__b91057ec__"